import React from "react";
import Table from "components/table";
import Button from "components/button/Button";
import { TiPlus } from "react-icons/ti";
import { ICourierService } from "../../types/courier.interface";

interface ICourierServiceProps {
  services: ICourierService[];
  openUpdateModal: (props: ICourierService) => void;
  openDeleteModal: (props: ICourierService) => void;
  onOpen: () => void;
}

const CourierServices: React.FC<ICourierServiceProps> = (props) => {
  const { services, openUpdateModal, openDeleteModal, onOpen } = props;
  const columnHeaders = [
    { name: "Nama" },
    { description: "Deskripsi" },
    { price_by_km: "Harga per Km" },
    { price_by_weight: "Harga per Kg" },
    { etd: "Estimasi Sampai" },
    { is_active: "Aktif" },
    { actions: "Aksi" },
  ];

  return (
    <section>
      <div className="flex w-full items-center justify-between">
        <p className="font-semibold text-gray-800">Layanan</p>
        <div className="flex gap-2">
          <Button
            size="fit"
            variant="primary"
            children={
              <div className="flex items-center gap-1">
                <TiPlus /> Layanan
              </div>
            }
            onClick={() => onOpen()}
          />
        </div>
      </div>
      {services.length > 0 ? (
        <div className="mb-10 flex items-start gap-3">
          <Table
            hasHeader={false}
            tableTitle=""
            tableData={services}
            columnHeaders={columnHeaders}
            handleUpdate={openUpdateModal}
            handleDelete={openDeleteModal}
          />
        </div>
      ) : (
        <div className="mb-10 flex items-start gap-3">
          <p className="w-full text-center text-gray-600 dark:text-white">
            Belum ada layanan yang ditambahkan
          </p>
        </div>
      )}
    </section>
  );
};

export default CourierServices;
